import { render, staticRenderFns } from "./LevelCompletion.vue?vue&type=template&id=13812b81&scoped=true&"
import script from "./LevelCompletion.vue?vue&type=script&lang=ts&"
export * from "./LevelCompletion.vue?vue&type=script&lang=ts&"
import style0 from "./LevelCompletion.vue?vue&type=style&index=0&id=13812b81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13812b81",
  null
  
)

export default component.exports